import { environment } from '@environments/environment';

export const baseUri = `${environment.apiUri}/review`;
export const review = `${baseUri}/:reviewId`;
export const note = `${baseUri}/:reviewId/note`;
export const byNoteId = `${note}/:noteId`;
export const publishedReview = `${baseUri}/published/:reviewId`;
export const byMoveId = `${baseUri}/moves/:moveId`;
